import React, { useEffect, useState } from "react";
import portfolioImg from "../../images/portfolioImg.png";
import { Link, useNavigate } from "react-router-dom";
import api from "../../api";
import { useDispatch, useSelector } from "react-redux";
import { useAlert } from "react-alert";
import axios from "axios";
import userAction from "../../redux/users/action";
import dashboardImg from "../../images/dashboardImg.png";
import { Loader } from "../global/loader";

export const Portfolio = () => {
  const userStore = useSelector((state) => state.userReducer);
  const alert = useAlert();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setUser } = userAction;
  const [wallets, setWallets] = useState(0);
  const [tx, setTx] = useState(0);
  const [portfolio, setPortfolio] = useState([]);
  const [loader, setLoader] = useState(false);

  const getExist = async () => {
    // e.preventDefault();
    // setLoader(true);
    try {
      //  await checkUserSession()

      let token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = token;
      const getResponse = await api.checkPortfolioExist(
        userStore?.users?.user?._id,
      );
      // console.log(getResponse);

      if (getResponse?.success) {
        // navigate(`/portfolio/dashboard/${getResponse?.res[0]?.wallet || 1}`);
        setWallets(getResponse?.walletCount);
        setTx(getResponse?.portfolioCount);
      } else {
        alert.error("Something went wrong");
        // setLoader(false);
      }
    } catch (e) {
      alert.show(e.message);
      // alert.show("Invalid Credentials or Account not verified");
      // setLoader(false);
    }
  };
  const getPortfolio = async () => {
    // e.preventDefault();
    setLoader(true);
    try {
      // axios.defaults.headers.common["Authorization"] =
      //   localStorage.getItem("token");
      const addResponse = await api.userPortfolioGet();
      // console.log(addResponse);

      if (addResponse?.success) {
        setPortfolio(addResponse?.res || []);
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (e) {
      console.log(e.message);
      // alert.show("Invalid Credentials or Account not verified");
      setLoader(false);
    }
  };

  // const checkUserSession = async () => {
  //   try {
  //     let token = localStorage.getItem("token");
  //     // console.log(token);
  //     if (token) {
  //       let payload = { token: token };
  //       const registerationResponse = await api.verifySession(payload);
  //       // console.log(registerationResponse);
  //       if (registerationResponse?.token) {
  //         axios.defaults.headers.common["Authorization"] =
  //           registerationResponse?.token;
  //       } else {
  //         dispatch(setUser({}));
  //         localStorage.removeItem("token");
  //         navigate("/");
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  useEffect(() => {
    if (userStore?.users?.user?._id) {
      // getExist();
      getPortfolio();
    }
  }, [userStore?.users]);

  return (
    <div className="portfolioSec">
      <div className="container">
        <div className="portfolioM mb-30 text-center">
          <div className="section-title display-block">
            <h1>Unlock Your Decentralized Trading Dashboard</h1>
            <p className="mb-4"> Your gateway to the decentralized economy </p>
          </div>
          {portfolio[0]?.type == "manual" ? (
            <Link
              to={`/portfolio/tx/${portfolio[0]?._id}`}
              className="default-btn"
            >
              Go to your portfolio
            </Link>
          ) : // <a
          //   className="default-btn"
          //   onClick={() => alert.show("THIS PAGE IS IN UNDER MAINTENANCE.")}
          // >
          //   Go to your portfolio
          // </a>
          portfolio[0]?.type == "wallet" ? (
            <Link
              to={`/portfolio/dashboard/${portfolio[0]?.wallet}`}
              className="default-btn"
            >
              Go to your portfolio
            </Link>
          ) : (
            // <a
            //   className="default-btn"
            //   onClick={() => alert.show("THIS PAGE IS IN UNDER MAINTENANCE.")}
            // >
            //   Go to your portfolio
            // </a>
            <Link to="/portfolio/connect" className="default-btn">
              Go to your portfolio
            </Link>
            // <a
            //   className="default-btn"
            //   onClick={() => alert.show("THIS PAGE IS IN UNDER MAINTENANCE.")}
            // >
            //   Go to your portfolio
            // </a>
          )}
          <div className="dashboardImg">
            <img className="img-fluid" src={dashboardImg} alt="" />
          </div>
        </div>
      </div>
      {loader && <Loader />}
    </div>
  );
};
